module.exports = __webpack_public_path__ + "img/DNADamage-PRCA_SpatialResearch.3f4a3912.png";